/* User Permissions */
export const userRoleConstants = Object.freeze({
  LSL_ADMIN: 'LSL_ADMIN',
  DEVELOPER: 'DEVELOPER',
})
